export default __webpack_public_path__ + "static/media/ipm.75a9a7f4.png";